{
	"transactionCardHeader": "Проверка на транзакция",
	"transactionCardDescriptionBold": "Искате да валидирате транзакция за който и да е проект?",
	"transactionCardDescriptionRegular": "Ако имате под ръка номер на транзакция, можете да го въведете тук и да валидирате транзакцията.",
	"showTransactionButton": "Покажи транзакцията",
	"transactionLabel": "Номер на транзакция",
	"errors": {
		"transactionIdRequired": "Номерът на транзакцията е задължителен.",
		"transactionNotFound": "Транзакцията не е намерена.",
		"transactionIdInvalid": "Невалиден номер на транзакция."
	}
}
